import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import StatusCell from '@cas/components/data-display/status-cell/StatusCell';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface SoftwareStatusCellRendererProps {
  value?: boolean;
}

export default function SoftwareStatusCellRenderer({
  value,
}: SoftwareStatusCellRendererProps): ReactElement | null {
  const { t } = useTranslation();

  if (typeof value !== 'undefined') {
    const label = value ? t('UpToDate') : t('Outdated');
    const status = value ? BadgeStatus.Healthy : BadgeStatus.Danger;

    return <StatusCell label={label} status={status} />;
  } else {
    return null;
  }
}
